/// SUBSCRIPTION
var subscriptionFreeGift = (e) => {
  var gifts = {39442344804433:{qtd: 0, need:0},40362244440145:{qtd: 0, need:0},41441080541265:{qtd: 0, need:0}}, defaultGift=40362244440145,skuToGift = {4097008959569:39442344804433,6608209739857:39442344804433,7451156054097:'none',7451157725265:'none',7451161428049:'none',7451160936529:'none',7451160215633:'none',7425809285201:'none'},hasSubscription = false, hasGift = false, cartItems = e.detail.cart.cart.items, update = {};
  for (var i=0; i<cartItems.length; i++) {
    if(cartItems[i].product_type == "Subscription" || (typeof cartItems[i].selling_plan_allocation === 'object' && cartItems[i].selling_plan_allocation !== null)) {
      giftSku = skuToGift[cartItems[i].product_id] || defaultGift;
      if(giftSku != "none") {
        hasSubscription = true;
        gifts[giftSku].need += cartItems[i].quantity;
      }
    }
    else if (cartItems[i].id in gifts) {
      gifts[cartItems[i].id].qtd = cartItems[i].quantity;
      hasGift = true;
    }
  }   
  if(hasSubscription || hasGift) {
    Object.keys(gifts).forEach(function(key,index) {
        if(gifts[key].qtd != gifts[key].need ) { update[key] = gifts[key].need }
    });

    if (!jQuery.isEmptyObject(update)) {
          console.log("Subscription Gift Start Update");
          jQuery.post('/cart/update.js', {updates:update}, function() {},'json').fail(function(xhr, textStatus, errorThrown) {  console.log(xhr.responseText)});
    }
  }
}	

var returnCurrency = () => {
  old_currency = Cookies.get("subscription_currency");
  Cookies.remove('subscription_currency')
  if(typeof subscription_page !== 'undefined') {  
    window.location = "https://www.sillygeorge.com/?currency="+old_currency;
  }
  else {
    if(window.location.search) {
      window.location.search = window.location.search + '&currency='+old_currency;
    } else {
      window.location.search = '?currency='+old_currency;
    }	
  }
}

// Promotion Vars
promo_products = promo_products || [];
promo_products.push(4737787134033);
promo_products.push(4688308174929);
promo_products.push(4736737280081);

// Remove starter kit
//promo_products = jQuery.grep(promo_products, function(value) {
//  return ([7075503472721,6613186281553,4669153706065].indexOf(value) == -1);
//});

var clear_lb_bundles = [4669173366865,6613362737233,4560678584401,4732650782801,4793506005073,6613400027217,6614698000465,6614346793041,4735884263505,6577289691217,6705932566609,6701362708561,7075503472721];
var mix_lb_bundles = [6768786997329,6613186281553,4669153706065,6768799842385,4731285930065,6613132509265];
var serum_ids = [4737787134033,4097008959569,7104520257617,7105461190737,4097008959569,4688308174929];
var sk_promo = [7107583148113,6613186281553,4669153706065];

// PROMOTIONS
var promotionLogic = (e) => {
  var gift_id = 4735090458705;
  var need_gift = 0;
  var has_gift = 0;
  var promo_limit = 2000 * Shopify.currency.rate;

  var cartItems = e.detail.cart.cart.items
  for (var i=0; i<cartItems.length; i++) { 
    // Check FREE gift
    if (cartItems[i].product_id == gift_id) {
      has_gift += cartItems[i].quantity;
    }
    if(e.detail.cart.cart.total_price>promo_limit && (market_handle == "ca" || market_handle == "us")) {
      need_gift = 1;
    }
  }
  if(has_gift != need_gift) {
    console.log("FREE Gift Update. Need "+need_gift+" QTDE: "+has_gift);
    if(PXUTheme.theme_settings.promo_enabled) {
      //jQuery.post('/cart/update.js', {updates:{32767470534737: need_gift}}, function() {},'json').fail(function(xhr, textStatus, errorThrown) {  console.log(xhr.responseText)});  
    }
  }
}

// TRIGGERS
document.addEventListener('rebuy:cart.change', (event) => { 
  //promotionLogic(event);
  subscriptionFreeGift(event);
  var carCounters = document.querySelectorAll('.cart_count');
  carCounters.forEach(function(el) {
    el.textContent = event.detail.cart.itemCount();
  });
});

